/**
 * Class for utility functions.
 *
 * @class      Utility (name)
 */
export class Utility
{
	/**
	 * Runs a given set of functions when document is ready.
	 *
	 * @param      {Function}  functions  The functions to run
	 * @return     {Promise}   Promise that resolves once DOM is ready and any
	 *                         provided functions have ran
	 */
	static async awaitDOMContentLoaded( functions = () => {} )
	{
		// Return a promise
		return new Promise(
			( resolve ) =>
			{
				// Is the DOM still loading?
				if ( document.readyState === 'loading' )
				{
					// Run it
					document.addEventListener(
						'DOMContentLoaded',
						() =>
						{
							// Run provided functions if any
							functions();

							// Resolve the promise
							return resolve();
						}
					);
				}
				// Already loaded
				else
				{
					// Run provided functions if any
					functions();

					// Resolve the promise
					return resolve();
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite-child/assets/js/utility/utility.js